import { render, staticRenderFns } from "./TabRow.vue?vue&type=template&id=50571e64&scoped=true&"
import script from "./TabRow.vue?vue&type=script&lang=js&"
export * from "./TabRow.vue?vue&type=script&lang=js&"
import style0 from "./TabRow.vue?vue&type=style&index=0&id=50571e64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50571e64",
  null
  
)

export default component.exports